//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import  UserInfoToast  from '@/components/toast/userInfo'
import mixinTxrNewWeb from '@/utils/mixin/mixinTxrNewWeb'
import mixinVerify from '@/utils/mixin/mixinVerify'
import { store, mutations} from '@/observable/store'
// import { uninsuredInfo } from '@/model/javaApi/present.js'
import { getFormatInfo,getDeScheme } from './index'

import  InstructionProtocol  from '@/views/stencil/components/instructionProtocol'
import  Inform  from '@/views/stencil/components/inform'
import  BaseInfo  from './components/BaseInfo'
import  InTitle  from '@/views/stencil/components/title'
import  Editor  from '@/views/stencil/components/editor'
import Tab from './components/tab.vue'
import Animation from './components/animation.vue'

export default {
    name: "attachPresent",
    mixins:[mixinTxrNewWeb,mixinVerify],
    data(){
        return {
            allData:{}, // 展示内容 
            modeShow:false,  //是否展示保险详情
            gainNames:[], // 滚动信息
            buyFlag:true, //是否支持领取保险
            // gainNo:'-',
            current:0, //详情选中
            refresh:'', //弹框内scroll 刷新
            key:0
        }
    },
    components:{
        InstructionProtocol,
        Inform,
        BaseInfo,
        InTitle,
        Editor,
        Tab,
        UserInfoToast,
        Animation
    },
    watch: {
        current(newValue, oldValue) {
            this.refresh = Date.parse(new Date());
        }
    },
    computed: {
        // 渠道商品code
        channelCommodityCode(){
            return this.$route.query.channelCommodityCode
        },
        // 主站订单号
        baseNo(){
            return this.$route.query.baseNo ||''
        },
        // 方案code
        scheme_code(){
            return this.$route.query.scheme_code || ''
        },
        // uid
        uid(){
            return store.uid
        }
    },
    created() {
        this.getInfo()
        // this.getOrderInfo()
        mutations.setAttachPresentInsur_name(this.$route.query.insur_name || '')
    },
    
    beforeRouteLeave: (to, from, next) => {
        // 除去条款页 保留参数
        if(to.path != '/iframePage'){
            mutations.setAttachPresentInsur_name('')
        }
        next()
    },
    mounted(){
        if(this.uid == 0){
            this.$refs.userlogin.showoast()
        }
        this.$nextTick(()=>{
            // 回溯视频
            this.postTX(this.channelCommodityCode)
        })
    },
    methods:{
        // 获取数据
        async getInfo(){
            let  schemeName = ""
            let data = {'channelCommodityCode':this.channelCommodityCode}
            // 获取格式化后的赠险信息
            this.allData = await getFormatInfo(data)
            // 刷新组件
            this.key = this.key+1
            // 获取当前选中的方案名称
            schemeName = getDeScheme(this.allData.schemes,this.scheme_code).schemeName
            // 埋点
            this.STATISTICS_CONFIG.insur_insurinfoinput_page({"ex":{scheme:schemeName }});
            console.log('格式化赠险数据结果：',this.allData)

            
        },
        //立即投保
        btnClick(){ 
            if(this.uid == 0){
                this.$refs.userlogin.showoast()
                return false
            }
            if(!this.buyFlag){
                this.$toast("当前订单状态不支持保险领取"); 
                return false
            }
            let fromPageData = this.$refs.baseInfo.fromPageData
            let schemeCurrent = this.$refs.baseInfo.schemeCurrent
            const data = {
                elements:this.$refs.baseInfo.fromPageData,
                channelCommodityCode:this.channelCommodityCode,
                isFollow:this.allData.isFollow,
                originalPrice:schemeCurrent.originalPrice, // 划线价
                commodityPrice:schemeCurrent.commodityPrice, 
                price:schemeCurrent.commodityPrice,
                baseNo:this.$route.query.baseNo || '', // 主站订单号
                traceId:store.TXoption.bizKey, // 回溯信息
                schemeCode:schemeCurrent.schemeCode, //方案code  目前只有一种
                ch:this.$route.query.ch || ''
            }
            // 统一核保
           this.verification(data,true).then(res=>{
               this.goConfirm()
               this.STATISTICS_CONFIG.insur_insurinfoinput_submit_click({"ex":{status:'pass' }})
           }).catch(res =>{
               this.STATISTICS_CONFIG.insur_insurinfoinput_submit_click({"ex":{status:'fail' }})
           })
        },
        // 去创建订单
        goConfirm(){
            let reviewType = this.$route.query.origin  ||'presentOrder'   //下单类型用于区分下单完成的后续流程
            if(reviewType  == 'presentOrder'){ // 赠险确认订单页 不需要下单
                this.mixinToAppPresentInsurance()
            }else{
                this.mixinCreatAnOrder()
            }
        },
        // 展示服务详情
        showDetail(){
            this.modeShow=true;
            this.current = 0
            this.STATISTICS_CONFIG.insur_insurinfoinput_insurdetail_click()

        },
        // getOrderInfo(){
        //     // 获取未投保页信息
        //     uninsuredInfo({'channelCommodityCode':this.channelCommodityCode,'baseNo':this.baseNo}).then(res =>{
        //         // this.gainInfo=res.gainInfo;
        //         // this.gainNo = res.gainNo.toString() || '0';
        //         if(!res){
        //             return false
        //         }
        //         this.gainNames = res.gainNames.map((item,index)=>{
        //             return {desc:item+'刚刚已投保',id:index}
        //         })
                
        //         if(!res.buyFlag){
        //             this.buyFlag = false
        //             this.$toast("当前订单状态不支持保险领取"); 
        //         }
        //     })
        // },
    }
}
